import {Utils} from "../utils/specific.mjs"



export class LimitFilter{
    constructor(){
        var _limit = 10;

        Object.defineProperty(this,'limit',{
            set : function(l){ _limit = l; },
            get : function(){ return _limit }
        });

    }

    // ==========
    // private 
    // ----------
    getLimit(){ return this.limit }


    // ==========
    // public 
    // ----------


    setLimit(limit){
        this.limit = limit;
    }

    filter(dataArray){ 
        return dataArray.slice(0, this.limit)
    }
}